import UpgradeAccountTransaction from './UpgradeAccountTransaction';

export default UpgradeAccountTransaction;
